import { ALLOWED_UPLOADS, MAX_UPLOAD_BYTES } from "../config/application";
const extensions = ["png", "jpg", "jpeg", "webp", "pdf"];
export function validateEvidenceFile(file: File): string[] {
  const errors: string[] = [];
  const extension = file.name.split(".").pop()?.toLowerCase() ?? "";
  if (!file.size) errors.push("The selected file is empty.");
  if (file.size > MAX_UPLOAD_BYTES)
    errors.push("File must be 10 MB or smaller.");
  if (!(ALLOWED_UPLOADS as readonly string[]).includes(file.type))
    errors.push("Use PNG, JPG, JPEG, WEBP, or PDF.");
  if (!extensions.includes(extension))
    errors.push("The file extension is not supported.");
  return errors;
}
